import { render, staticRenderFns } from "./invite-page.vue?vue&type=template&id=70aaa856&scoped=true&lang=pug&"
import script from "./invite-page.vue?vue&type=script&lang=ts&"
export * from "./invite-page.vue?vue&type=script&lang=ts&"
import style0 from "./invite-page.vue?vue&type=style&index=0&id=70aaa856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aaa856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
